import React from "react";

function SettingsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        id="Path_18517"
        data-name="Path 18517"
        d="M10,18a8,8,0,1,1,8-8A8,8,0,0,1,10,18Zm0-1.6A6.4,6.4,0,1,0,3.6,10,6.4,6.4,0,0,0,10,16.4ZM9.2,6h1.6V7.6H9.2Zm0,3.2h1.6V14H9.2Z"
        transform="translate(-2 -2)"
      />
    </svg>
  );
}

export default SettingsIcon;
